<template>
  <div class="body-width" >
    <div class="div-row div-pad-top news-Medium-24" >
      海上立体搜救演练系统
    </div>
    <div class="div-row">
      <p class="indentation">V.Dragon-SAR 5000型海上立体搜救演练系统满足《国际航空和海上搜寻救助手册》中关于模拟演练的要求，用于海上搜救人员实操培训与评估、搜救预案制定、分析、演练以及搜救决策方案预演等领域，能大幅度地降低搜救演习成本，有效提高受训者的搜救能力。</p>
    </div>
    <div class="img_pad">
      <img src="../../../../assets/images/productcenter/hsyl/ltsj/1.png">
    </div>
    <div class="div-row">
      <p class="indentation">本系统基于HLA（High Level Architecture）构建，主要由RCC仿真单元、遇险船仿真单元、救助船仿真单元、搜救直升机仿真单元与视频监控系统组成，具有如下特点：</p>
    </div>
    <div align="left">
      <ul>
        <li><span>丰富的搜救训练场景</span></li>
        <li><span>多种典型的搜寻模式可供选择</span></li>
        <li><span>仿真单元配置灵活</span></li>
        <li><span>海空协同演练</span></li>
        <li><span>救生信号和应急无线电设备等使用</span></li>
        <li><span>救生艇筏释放及回收</span></li>
      </ul>
    </div>
    <div class="img_pad img_left row" align="left">
      <div>
        <img  src="../../../../assets/images/productcenter/hsyl/ltsj/2.png">
        <div class="div-top3">
         RCC仿真单元
        </div>
      </div>
      <div class="img_left80">
        <img src="../../../../assets/images/productcenter/hsyl/ltsj/3.png">
        <div class="div-top3">
          救助船仿真单元
        </div>
      </div>

    </div>
    <div class="img_pad1 img_left row" align="left">
      <div>
        <img src="../../../../assets/images/productcenter/hsyl/ltsj/4.png">
        <div class="div-top3">
        遇险船仿真单元
        </div>
      </div>
      <div class="img_left80">
        <img  src="../../../../assets/images/productcenter/hsyl/ltsj/5.png">
        <div class="div-top3">
          搜救直升机仿真单元
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "hsltsjylxt"
  }
</script>

<style scoped>
  .div-pad-top {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .img_pad{
    padding: 30px 0px 30px 0px;
  }
   .img_pad1{
    padding: 30px 0px 0px 0px;
  }
  .img_left{
    padding-left: 35px;
  }
  p{
    font-size: 16px;
    color: #666666;
  }
  li{
    color: #2E79BE;

  }
  li span{
    color: #666666;
  }
  .div-top3 {
    padding-top: 10px;
    color: #b6b6b6;
    text-align: center;
  }
  .img_left80{
    padding-left: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hsylxlcp/hsltsjylxt.vue